export const PLACE_ID="63c09e778f3c05bdbbefab21"
export const API_BASE_URL =  `https://api.upoui.com/v1/cms/${PLACE_ID}`
export const API_KEY = '46e92211df05779027952985c07f26a8'
export const API_WEATHER_URL =  'https://api.openweathermap.org/data/2.5/weather?lat='
export const API_REVIEW = "https://api.upoui.com/v1/review"
export const API_PLACES = "https://places.api.upoui.com/places?distance_filter="
